import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsTargetProducts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCTS,
		options
	)
}
function _getRegulationsTargetProductPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_PREVIEW,
		options
	)
}
function _getRegulationsTargetProductPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_POPUP,
		options
	)
}

function _createRegulationsTargetProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].CREATE_REGULATIONS_TARGET_PRODUCT,
		options
	)
}

function _getRegulationsTargetProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT,
		options
	)
}

function _patchRegulationsTargetProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PATCH_REGULATIONS_TARGET_PRODUCT,
		options
	)
}

function _putRegulationsTargetProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PUT_REGULATIONS_TARGET_PRODUCT,
		options
	)
}

function _deleteRegulationsTargetProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].DELETE_REGULATIONS_TARGET_PRODUCT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCTS]: _getRegulationsTargetProducts,

	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_PREVIEW]: _getRegulationsTargetProductPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_POPUP]: _getRegulationsTargetProductPopup,

	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].CREATE_REGULATIONS_TARGET_PRODUCT]: _createRegulationsTargetProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT]: _getRegulationsTargetProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PATCH_REGULATIONS_TARGET_PRODUCT]: _patchRegulationsTargetProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PUT_REGULATIONS_TARGET_PRODUCT]: _putRegulationsTargetProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].DELETE_REGULATIONS_TARGET_PRODUCT]: _deleteRegulationsTargetProduct,
}